import React from 'react'
import SimpleHeader from '../../../simple-header/SimpleHeader';

function DefaultSimpleHeader() {
  return (
    <SimpleHeader/>
  )
}

export default DefaultSimpleHeader
